import { Series } from "../MultipleLine/types";
import { ReadoutLine } from "./types";

export const stepFor = (key: string, index: number, lastIndex: number) => {
  switch (key) {
    case "ArrowLeft":
      return Math.max(0, index - 1);
    case "ArrowRight":
      return Math.min(lastIndex, index + 1);
    case "Home":
      return 0;
    case "End":
      return lastIndex;
    default:
      return null;
  }
};

export const readoutLinesOf = (
  series: Series[],
  index: number,
): ReadoutLine[] =>
  series.map((line) => ({
    label: line.label,
    value: line.valueFormatter(line.data[index] ?? null),
  }));

export const readoutTextOf = (
  date: string,
  lines: ReadoutLine[],
  footerText: string[] = [],
) =>
  [date, ...lines.map(({ label, value }) => `${label} ${value}`), ...footerText]
    .map((part) => `${part}.`)
    .join(" ");
